/*
 * On GOAT infra, webpack bundles are served from a CDN (CloudFront). Rails'
 * asset_host rewrites server-rendered <script>/<link> tags to point there,
 * but dynamically loaded chunks (code-split JS/CSS) use webpack's built-in
 * publicPath ("/" in production). Without this override, those chunks resolve
 * against the app host — and during deploys, old chunks get removed, causing
 * chunk-load errors.
 *
 * This module reads the CDN origin from PublicConfig (injected by Rails as
 * window.PUBLIC_CONFIG) and sets __webpack_public_path__ so all dynamic
 * chunks load from the CDN. It must be a separate entry module — not an
 * import inside an entry file — because ES imports are hoisted above inline
 * code, and __webpack_public_path__ must be set before any other module
 * executes.
 *
 * On local dev / non-GOAT environments, bundles_domain is empty and the
 * build-time publicPath is left untouched.
 */

/* eslint-disable no-var, no-underscore-dangle, @typescript-eslint/naming-convention */
declare var __webpack_public_path__: string;

const bundlesDomain = window.PUBLIC_CONFIG?.bundles_domain;

if (typeof bundlesDomain === "string" && bundlesDomain !== "") {
  __webpack_public_path__ = `https://${bundlesDomain}/`;
}
